import { render, staticRenderFns } from "./Jitsi.vue?vue&type=template&id=79ac60d1&scoped=true&"
import script from "./Jitsi.vue?vue&type=script&lang=js&"
export * from "./Jitsi.vue?vue&type=script&lang=js&"
import style0 from "./Jitsi.vue?vue&type=style&index=0&id=79ac60d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ac60d1",
  null
  
)

export default component.exports